import { render, staticRenderFns } from "./MultipleOption.vue?vue&type=template&id=0da68636"
import script from "./MultipleOption.vue?vue&type=script&lang=js"
export * from "./MultipleOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports